import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/homePage";
import AppLayout from "./components/layout/AppLayout";
import ApropoPage from "./pages/aPropoPage";
import SoutienPage from "./pages/soutienPage";
import RejoindrePage from "./pages/rejoindrePage";
import RealisationPage from "./pages/realisationPage";
import ContactPage from "./pages/contactPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginPage from "./pages/adminPages/loginPage";
import ModalOverlay from "./components/modelAds";
import VerifCode from "./pages/adminPages/verifCodePage";
import AppLayoutAdmin from "./pages/adminPages/appLayoutAdmin";
import Dashbord from "./pages/adminPages/dashbordAdmin";
import MissionListe from "./pages/adminPages/listeMissionPage";
import JobForm from "./pages/adminPages/addMissionPage";
import ContactListe from "./pages/adminPages/contactList";
import NewslettreListe from "./pages/adminPages/NewsLetter";
import CandidatureListe from "./pages/adminPages/candidatureListe";
import PaiementListe from "./pages/adminPages/paiementListe";

import RealisationListePages from "./pages/adminPages/realisationListe/realisationListe";
import RealisationForm from "./pages/adminPages/addRealisation";
import ProtectedRoute from "./pages/adminPages/protectedRoute";
import UserListePages from "./pages/adminPages/userListe";
import MentionsLegales from "./components/mentionslégales";

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route
          path="/"
          element={
            <AppLayout>
              <ModalOverlay />
              <HomePage />
            </AppLayout>
          }
        />
        <Route
          path="/aPropo"
          element={
            <AppLayout>
              <ModalOverlay />
              <ApropoPage />
            </AppLayout>
          }
        />
        <Route
          path="/faire-don"
          element={
            <AppLayout>
              <ModalOverlay />
              <SoutienPage />
            </AppLayout>
          }
        />
        <Route
          path="/rejoignez-nous"
          element={
            <AppLayout>
              <ModalOverlay />
              <RejoindrePage />
            </AppLayout>
          }
        />

        <Route
          path="/realisation"
          element={
            <AppLayout>
              <ModalOverlay />
              <RealisationPage />
            </AppLayout>
          }
        />

        <Route
          path="/realisation/:id"
          element={
            <AppLayout>
              <ModalOverlay /> <RealisationPage />
            </AppLayout>
          }
        />

        <Route
          path="/contact"
          element={
            <AppLayout>
              <ModalOverlay />
              <ContactPage />
            </AppLayout>
          }
        />
        <Route
          path="/mentionsLegales"
          element={
            <AppLayout>
              <ModalOverlay />
              <MentionsLegales />
            </AppLayout>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/verif-code" element={<VerifCode />} />
        <Route
          path="/dashbord"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <Dashbord />
              </AppLayoutAdmin>
            </ProtectedRoute>
          }
        />
        <Route
          path="/mission-liste"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <MissionListe />
              </AppLayoutAdmin>
            </ProtectedRoute>
          }
        />
        <Route
          path="/realisation-liste"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <RealisationListePages />
              </AppLayoutAdmin>
            </ProtectedRoute>
          }
        />
        <Route
          path="/paiement-liste"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <PaiementListe />
              </AppLayoutAdmin>
            </ProtectedRoute>
          }
        />
        <Route
          path="/candidature-liste"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <CandidatureListe />
              </AppLayoutAdmin>
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact-liste"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <ContactListe />
              </AppLayoutAdmin>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-liste"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <UserListePages />
              </AppLayoutAdmin>
            </ProtectedRoute>
          }
        />
        <Route
          path="/newsletter-liste"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <NewslettreListe />
              </AppLayoutAdmin>{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-mission"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <JobForm />
              </AppLayoutAdmin>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-mission/:id"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <JobForm />
              </AppLayoutAdmin>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-realisation"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <RealisationForm />
              </AppLayoutAdmin>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-realisation/:id"
          element={
            <ProtectedRoute>
              <AppLayoutAdmin>
                <RealisationForm />
              </AppLayoutAdmin>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
